/* <collection-tabs> — #114: smooth sub-collection switching on the
   collection template. Blog-tabs pattern (assets/blog.js): tab clicks
   re-fetch THIS section for the target collection through the Section
   Rendering API (fetchSections from critical.js) and swap this element's
   content in place — active-tab styling, grid, and pagination all arrive
   rendered. URL updates via replaceState; back/forward reloads to re-sync
   server state; any fetch/parse failure falls back to full navigation.
   Tab links stay real <a>s = the no-JS fallback. Click-driven => EAGER. */

import { fetchSections } from './critical.js';

class CollectionTabs extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.getAttribute('section-id');
    this.token = 0;

    this.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const tab = event.target.closest('a[aria-current], li a');
      if (!tab || !this.sectionId) return;
      const href = tab.getAttribute('href') || '';
      if (!href.startsWith('/collections/')) return;
      /* Only intercept the tab nav links (inside the tab <ul>), not product
         cards or banner links. */
      if (!tab.closest('ul')) return;
      if (tab.closest('article')) return;
      event.preventDefault();
      if (tab.getAttribute('aria-current') === 'true') return;
      this.switchTab(tab.href);
    });

    this.onPopstate = () => window.location.reload();
    window.addEventListener('popstate', this.onPopstate);
  }

  disconnectedCallback() {
    window.removeEventListener('popstate', this.onPopstate);
  }

  async switchTab(url) {
    const token = ++this.token;
    this.setAttribute('aria-busy', 'true');
    try {
      const sections = await fetchSections(this.sectionId, url);
      if (token !== this.token) return;
      const doc = new DOMParser().parseFromString(sections[this.sectionId], 'text/html');
      const incoming = doc.querySelector('collection-tabs');
      if (!incoming) throw new Error('no collection-tabs in response');
      this.replaceChildren(...incoming.childNodes);
      window.history.replaceState({}, '', url);
      /* Land the swapped grid in view without a jump past the banner. */
      const top = this.getBoundingClientRect().top + window.scrollY - 140;
      if (window.scrollY > top) window.scrollTo({ top, behavior: 'instant' });
    } catch (error) {
      window.location.href = url;
    } finally {
      if (token === this.token) this.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('collection-tabs')) customElements.define('collection-tabs', CollectionTabs);
